import Reveal from "@/components/base/Reveal";

export default function DisclaimerSection() {
  return (
    <section id="about" className="scroll-mt-20 w-full bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <Reveal>
          <div className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="lg:col-span-3 bg-primary-500 p-6 md:p-7 flex flex-col justify-center">
                <i className="ri-error-warning-line text-3xl text-background-50 dark:text-foreground-950 mb-3"></i>
                <h2 className="font-heading font-bold text-background-50 dark:text-foreground-950 text-xl md:text-2xl">
                  免责与内容说明
                </h2>
                <p className="mt-2 text-xs text-background-50/80 leading-relaxed">
                  阅读前请先了解本站的定位与内容边界。
                </p>
              </div>

              <div className="lg:col-span-9 p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
                      <i className="ri-file-text-line text-primary-600"></i>
                      内容来源
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      本站内容由公开网络信息汇总整理，用于话题梳理与信息索引，不生产、也不证实任何爆料。
                    </p>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
                      <i className="ri-shield-user-line text-accent-600"></i>
                      关于隐私
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      不收集、不保存访客个人信息，页面筛选与切换仅作用于本地已展示的内容。
                    </p>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
                      <i className="ri-eye-off-line text-secondary-700"></i>
                      传闻标注
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      对无法确认的说法，我们会标注为传闻或热议，请勿将其理解为已经发生的事实。
                    </p>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 flex items-center gap-2">
                      <i className="ri-refresh-line text-primary-600"></i>
                      更正渠道
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      如发现页面内容与公开事实不符，我们会根据可靠来源及时调整，力求保持信息中性。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}